import React from 'react';

interface Props {}

const Up = (props: Props) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7L6 4L9 7" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default Up;
